import React, { Component } from "react";
import { DataGrid } from "@mui/x-data-grid";
import { withCompanies } from "../../../shared/containers/containerCompanies";
import { withAuth } from "../../../shared/containers/containerAuth";

import clsx from "clsx";
import CmsCompanyCreateTools from "../CmsCompany/CmsCompanyCreateTools";
import styles from "./../CmsCompany/cmsCompanyTable.module.scss";

import "./cellTable.css";
import { dateGridLocalTextOptions } from "../../../shared/services/dataGridLocalTextOptions";

class CmsCompaniesTable extends Component {
  componentDidMount() {
    this.props.onRowSelectionModelChange([]);
  }

  getColumns() {
    const { data } = this.props;

    const renderTitleCell = (params) => {
      return (
        <a href={`/cms/companies/${params.row.id}`} target="_blank" rel="noreferrer">
          {params.row.title}
        </a>
      );
    };

    const stylePayment = (params) => {
      return clsx("payment-cell", {
        negative: params.row.datePayment < new Date(),
      });
    };

    return [
      {
        field: "title",
        headerName: "Наименование",
        renderCell: renderTitleCell,
        width: 400,
        editable: data.permissions.includes(10003),
      },

      { field: "unitCount", headerName: "Количесвто транспортных средств", width: 150, type: "number" },
      { field: "unitInActiveCount", headerName: "Количесвто не активных транспортных средств", width: 150, type: "number" },
      { field: "dateCreation", headerName: "Дата создания", width: 110, type: "date" },
      {
        field: "datePayment",
        headerName: "Олачен до",
        width: 100,
        editable: data.permissions.includes(10003),
        type: "date",
        cellClassName: stylePayment,
      },
      {
        field: "storagePeriod",
        headerName: "Срок хранения (мес.)",
        width: 160,
        editable: data.permissions.includes(10003),
        type: "number",
      },
      { field: "deviceCount", headerName: "Количесвто устройств", width: 160, type: "number" },
      { field: "rentCount", headerName: "Количесвто арендных устройств", width: 200, type: "number" },
    ];
  }

  processRowUpdate(newRow) {
    const { onUpdateCompany } = this.props;
    const updatedRow = { ...newRow };
    onUpdateCompany(updatedRow);

    return updatedRow;
  }

  getRows() {
    const { ownershipArea } = this.props;
    return ownershipArea.companies === undefined
      ? []
      : ownershipArea.companies.map((company) => {
          const datePayment = new Date(Date.parse(company.datePayment));
          const dateCreation = new Date(Date.parse(company.dateCreation));

          return {
            ...company,
            datePayment: new Date(datePayment.setHours(-new Date().getTimezoneOffset() / 60 + datePayment.getHours())),
            dateCreation: new Date(dateCreation.setHours(-new Date().getTimezoneOffset() / 60 + dateCreation.getHours())),
          };
        });
  }

  render() {
    const { ownershipArea, onRowSelectionModelChange } = this.props;

    return (
      <>
        <div className={styles.cmsCompanyTableInfo}>
          <div>Всего устройств: {ownershipArea.deviceCount}</div>
          <div>Всего устройств в аренде: {ownershipArea.deviceRentCount}</div>
          <div>Всего транспортных средств: {ownershipArea.unitCount}</div>
          <div>Всего активных транспортных средств: {Math.abs(ownershipArea.unitCount - ownershipArea.unitInActiveCount)}</div>
          <div>Всего не активных транспортных средств: {ownershipArea.unitInActiveCount}</div>
        </div>
        <CmsCompanyCreateTools ownershipAreaId={ownershipArea.id} />
        <div className={styles.cmsCompaniesTable}>
          <DataGrid
            rowHeight={30}
            ref={"DataGrid"}
            disableColumnSelector={true}
            disableColumnFilter={true}
            localeText={{
              ...dateGridLocalTextOptions,
              footerRowSelected: (count) => `Cтрок выбранно: ${count}`,
            }}
            rows={this.getRows()}
            columns={this.getColumns()}
            checkboxSelection={this.props.data.permissions.includes(80002)}
            disableRowSelectionOnClick
            onRowSelectionModelChange={onRowSelectionModelChange}
            processRowUpdate={this.processRowUpdate.bind(this)}
          />
        </div>
      </>
    );
  }
}

export default withCompanies(withAuth(CmsCompaniesTable));
